export enum LeftNavEventType {
	RENDER = 'leftnav-render',
	NAV_ITEM_SCROLLED = 'navItemScrolled',
	NAV_ITEM_CLICKED = 'navItemScrollClicked'
}

/**
 * Helps to know when the Menu is open, or close
 */
export enum CVLeftNavEventType {
	OPEN_CLOSE = 'cv-left-nav-open-close',
	NAV_ITEMS_CHANGED = 'NavItemsChanged'
}

// navItemScrolled
// navItemScrollClicked
